// ***************************************
// tgfFramework
//
// This object deals with the global framework.
//
// Copyright 2015-2016 Tingly Games B.V.
// Last Changed: 04-03-2016
// ***************************************
import { tgfSettings } from "./tgfSettings";
import { tgfGraphics } from "./tgfGraphics";
import { tgfFunctions } from "./tgfFunctions";
import { tgfStatus } from "./tgfStatus";
import { tgfAudio } from "./tgfAudio";
tgfSettings.frameworkDefaults = {
    name: "Tingly Games Framework",
    id: "tgf",
    version: "3.0.0",
    load: {
        moments: [],
        required: [],
        minTime: 0,
        maxTime: 1 // Maximal loading time (in seconds) for the other moments before continuing
    },
    initErrors: true,
    initGraphics: true,
    initConsole: false,
    initProfile: true,
    initStatus: true,
    initDictionary: false,
    initAnalytics: false,
    initAudio: true,
    pauseOnHide: true,
    pauseOnLosingFocus: true,
    extraLoadMoments: [],
    extraLoadRequired: [] // Extra required loading moments
};
// The constructor
var TGFFramework = function () {
    "use strict";
};
// ***************************************
// Initialization
// ***************************************
// Initialize the framework
TGFFramework.prototype.initialize = function (settings, onSuccess, onFail) {
    var _this = this;
    // Initialize the framework itself
    this._setProperties(tgfSettings.frameworkDefaults);
    this._setProperties(settings);
    // Initialize the various framework components that can be done now (the order might matter!)
    if (this.initGraphics) {
        tgfGraphics.initialize(tgfSettings.graphics);
    }
    if (this.initStatus) {
        tgfStatus.initialize(tgfSettings.statusStorage, tgfSettings.status);
    }
    // Start the loading of the resources
    this._loadResources(this.extraLoadMoments, this.extraLoadRequired);
    // Create the timer to check whether initialization is ready
    this.initComplete = false;
    this.initFailed = false;
    this.initOnSuccess = onSuccess;
    this.initOnFail = onFail;
    this.initState = 0;
    this.initTimer = window.setInterval(function () { TGFFramework.prototype.checkInitState.call(_this); }, 50);
};
// Check the initialization state
TGFFramework.prototype.checkInitState = function () {
    "use strict";
    if (this.initState === 0) // Waiting for the status to be initialized
     {
        if (!this.initStatus || tgfStatus.initComplete || tgfStatus.initFailed) {
            this.initState = 1;
        }
    }
    if (this.initState === 1) // Waiting for the loading to be completed
     {
        if (tgfFunctions.loadComplete()) {
            this.initState = 2;
            if (this.initAudio) {
                tgfAudio.initialize(tgfSettings.audio);
            }
            // Apply a hack to clear browser back buffer on Android stock browser
            tgfGraphics.performBufferClearHack();
        }
    }
    if (this.initState === 2) { // Ready
        this.initComplete = true;
        this.initFailed = false;
        if (this.initStatus) {
            this.initComplete = this.initComplete && tgfStatus.initComplete;
        }
        if (this.initStatus) {
            this.initFailed = this.initFailed || tgfStatus.initFailed;
        }
        window.clearInterval(this.initTimer);
        if (this.initComplete && this.initOnSuccess) {
            this.initOnSuccess();
        }
        if (this.initFailed && this.initOnFail) {
            this.initOnFail();
        }
        this._initEvents();
    }
};
// ***************************************
// Internal methods
// ***************************************
// Set a number of properties
TGFFramework.prototype._setProperties = function (properties) {
    "use strict";
    var property;
    if (typeof properties !== "object") {
        return;
    }
    for (property in properties) {
        if (properties.hasOwnProperty(property)) {
            this[property] = tgfFunctions.copyValue(properties[property]);
        }
    }
};
// Load the framework resources
TGFFramework.prototype._loadResources = function (extraMoments, extraRequired) {
    "use strict";
    var moments = [], required = [];
    if (extraMoments === undefined) {
        extraMoments = [];
    }
    if (extraRequired === undefined) {
        extraRequired = [];
    }
    moments = moments.concat(this.load.moments);
    moments = moments.concat(extraMoments);
    required = required.concat(this.load.required);
    required = required.concat(extraRequired);
    tgfFunctions.loadStart({ moments: moments, required: required, minTime: this.load.minTime, maxTime: this.load.maxTime });
    this.loadHandled = false;
};
// ***************************************
// Handling a number of events
// ***************************************
// Initialize the event handlers
TGFFramework.prototype._initEvents = function () {
    "use strict";
    if (this.pauseOnHide) {
        document.addEventListener("visibilitychange", this._handleVisibilityChange, false);
    }
    if (this.pauseOnLosingFocus) {
        tgfGraphics.container.onfocus = this._handleFocus;
        tgfGraphics.container.onblur = this._handleBlur;
    }
};
TGFFramework.prototype._handleVisibilityChange = function () {
    if (document.hidden) {
        tgfFunctions.pauseAll();
    }
    else {
        tgfFunctions.resumeAll();
    }
};
// ***************************************
// Create the object
// ***************************************
export var tgfFramework = new TGFFramework();
